import React, { useState, useEffect } from "react";
import { addConnectionsToActionButtons, isUrlImage, handleGoogleDriveLink } from "@util/Scripts";
import { Select } from "antd";
import IntlMessages from "@util/IntlMessages";
import SettingsModal from "components/Modal/SettingsModal";
import ActionsDropdown from "../../../ActionsDropdown";
import moment from "moment";
import "../list.less";
import "./mapComponent.less";
import { Button, Spin, Input, DatePicker } from "../../../BP2Components";
import ProcessesDropdown from "../../../ProcessesDropdown/ProcessesDropdown";
import { useIntl } from "react-intl";

const { Option } = Select;

const ListCell = ({
   urlButton,
   editable,
   isChatButtonVisible,
   currentSheet,
   value,
   row,
   model,
   onChange,
   columns,
   toggle,
   singleColumn,
   listResponse,
   align,
   board,
   center,
   widgetId,
   imageWidth,
   imageDownloadAvailable,
   editFormError,
   technamesPresenterForm,
   enumType,
   techName,
   originalActions,
   presenterForm,
   listId,
}) => {
   const [selectOptions, setSelectOptions] = useState(null);
   const intl = useIntl();
   const isCellValueAFile = (value) => {
      if (value) {
         return (value?.[0]?.altUrl ?? value[0]?.altUrl1 ?? value[0]?.fileUrl) ? true : false;
      } else {
         return false;
      }
   };

   const chatButtonTranslationKey = board?.sheets
      ?.find((elem) => elem.id === currentSheet)
      ?.widgets?.find((elem) => elem.id === widgetId)?.chatButtonTitle;

   const currentWidget = board?.sheets
      ?.find((elem) => elem.id === currentSheet)
      ?.widgets?.find((elem) => elem.id === widgetId);
   let actions = addConnectionsToActionButtons(
      board.connections,
      originalActions,
      widgetId,
      "",
      intl,
   );

   const getFileObject = (value, imageWidth, imageDownloadAvailable) => {
      const styleModal = {
         margin: "0px 0px 0px 50%",
         transform: "translate(-50%, 0)",
      };
      const styleImage = {
         margin: "auto",
         height: "100%",
         display: "block",
      };
      return (
         <>
            {isCellValueAFile(value) &&
            isUrlImage(value[0]?.altUrl ?? value[0]?.altUrl1 ?? value[0]?.fileUrl) ? (
               <SettingsModal
                  customAvatar={
                     <img
                        className="mark-img"
                        style={{ width: imageWidth, height: imageWidth }}
                        alt={value[0].id}
                        src={value[0]?.altUrl ?? value[0]?.altUrl1 ?? value[0]?.fileUrl}
                     />
                  }
                  children={
                     <img
                        className="drive-img-opened"
                        alt={value[0].id}
                        src={value[0]?.altUrl ?? value[0]?.altUrl1 ?? value[0]?.fileUrl}
                        style={styleImage}
                     />
                  }
                  title={
                     imageDownloadAvailable ? (
                        <a
                           href={value[0]?.altUrl ?? value[0]?.altUrl1 ?? value[0]?.fileUrl}
                           download
                        >
                           <Button
                              buttonType="primary"
                              className="ant-btn-primary"
                              style={styleModal}
                           >
                              <IntlMessages id="image.downloadImage" />
                           </Button>
                        </a>
                     ) : (
                        "Image"
                     )
                  }
               />
            ) : (isCellValueAFile(value) && value[0]?.altUrl?.includes("drive.google.com")) ||
              value[0]?.altUrl1?.includes("drive.google.com") ||
              value[0]?.fileUrl?.includes("drive.google.com") ? (
               <SettingsModal
                  customAvatar={
                     <img
                        className="drive-img"
                        style={{ width: imageWidth, height: imageWidth }}
                        alt={value[0].id}
                        src={handleGoogleDriveLink(
                           "view",
                           value[0]?.altUrl ?? value[0]?.altUrl1 ?? value[0]?.fileUrl,
                        )}
                     />
                  }
                  children={
                     <img
                        className="drive-img-opened"
                        alt={value[0].id}
                        src={handleGoogleDriveLink(
                           "view",
                           value[0]?.altUrl ?? value[0]?.altUrl1 ?? value[0]?.fileUrl,
                        )}
                        style={styleImage}
                     />
                  }
                  title={
                     imageDownloadAvailable ? (
                        <a
                           href={handleGoogleDriveLink(
                              "download",
                              value[0]?.altUrl ?? value[0]?.altUrl1 ?? value[0]?.fileUrl,
                           )}
                           download
                        >
                           <Button
                              buttonType="primary"
                              className="ant-btn-primary"
                              style={styleModal}
                           >
                              <IntlMessages id="image.downloadImage" />
                           </Button>
                        </a>
                     ) : (
                        "Image"
                     )
                  }
               />
            ) : (
               <a
                  href={value[0]?.altUrl ?? value[0]?.altUrl1 ?? value[0]?.fileUrl}
                  target="_blank"
                  rel="noopener noreferrer"
               >
                  {value[0].name}
               </a>
            )}
         </>
      );
   };
   useEffect(() => {
      if (technamesPresenterForm) {
         if (technamesPresenterForm.find(({ techname }) => techname === techName)?.sqlValues) {
            // For now i'm leaving that 10000, in the future we can do some kind of 'search' to optimize that
            if (
               technamesPresenterForm.find(({ techname }) => techname === techName)?.sqlValues
                  .length < 10000
            ) {
               setSelectOptions(
                  technamesPresenterForm
                     .find(({ techname }) => techname === techName)
                     ?.sqlValues.reduce((previousValue, currValue) => {
                        const sqlId = currValue.value;
                        const sqlName = currValue.label;
                        previousValue[sqlId] = sqlName;
                        return previousValue;
                     }, {}),
               );
            } else {
               setSelectOptions([]);
            }
         } else if (technamesPresenterForm.find(({ techname }) => techname === techName)?.options) {
            setSelectOptions(
               technamesPresenterForm.find(({ techname }) => techname === techName)?.options,
            );
         }
      }
   }, [technamesPresenterForm]);

   const returnBasicCellValue = (value) => {
      let renderValue = value;
      if (typeof value === "string" && value.includes("<") && value.includes("</")) {
         renderValue = <div dangerouslySetInnerHTML={{ __html: value }} />;
      }
      return renderValue;
   };

   if (editable && techName) {
      if (
         !editFormError &&
         technamesPresenterForm?.find(({ techname }) => techname === techName)?.UIP_EDYT === "1"
      ) {
         if (enumType === "sql" || enumType === "dict") {
            return selectOptions ? (
               <Select
                  showSearch
                  disabled={selectOptions?.length === 0}
                  defaultValue={value?.label ? value?.label : value?.value}
                  onChange={(e) => {
                     onChange({
                        id: Object.entries(selectOptions).find(([id, val]) => val == e)[0],
                        value: e,
                     });
                  }}
               >
                  {Object.entries(selectOptions).map(([id, val]) => (
                     <Option value={val} key={id}>
                        {val}
                     </Option>
                  ))}
               </Select>
            ) : (
               <Spin className="editableCell-spin" />
            );
         } else if (enumType == "date" || enumType == "date_time") {
            return (
               <DatePicker
                  size="small"
                  className="gx-ml-1"
                  defaultValue={moment(value)}
                  onChange={(e) => {
                     if (e?.format("yyyy-MM-DD HH:mm:ss")) {
                        onChange(e?.format("yyyy-MM-DD HH:mm:ss"));
                     }
                  }}
               />
            );
         } else {
            return (
               <Input
                  style={{ paddingLeft: "5px" }}
                  value={value !== null ? (typeof value === "object" ? value.value : value) : ""}
                  disabled={typeof value === "object"}
                  onChange={(e) => onChange(e.target.value)}
               />
            );
         }
      } else if (editFormError === true) {
         return (
            <span style={{ opacity: 0.5 }}>
               <IntlMessages id="list.formError" />
            </span>
         );
      } else if (
         technamesPresenterForm?.find(({ techname }) => techname == techName)?.UIP_EDYT === "0"
      ) {
         return (
            <Input
               style={{ paddingLeft: "5px" }}
               value={value !== null ? (typeof value === "object" ? value.value : value) : ""}
               disabled={true}
            />
         );
      } else {
         return <Spin className="editableCell-spin" />;
      }
   } else {
      // If cell is not editable
      return isCellValueAFile(value) ? (
         <div style={{ padding: "0px 12px" }}>
            {getFileObject(value, imageWidth, imageDownloadAvailable)}
         </div>
      ) : enumType === "File" && typeof value === "string" && value ? (
         <div style={{ padding: "0px 12px" }}>
            <a href={value} rel="noopener noreferrer" download>
               <Button buttonType="primary" className="ant-btn-primary">
                  <IntlMessages id="list.downloadFile" />
               </Button>
            </a>
         </div>
      ) : (
         <div
            style={{
               padding: "0px 10px",
               textAlign: center ? "center" : align,
            }}
         >
            {singleColumn === "api_recordactions" && (
               <ActionsDropdown
                  urlButton={urlButton}
                  hiddenDropdown={currentWidget?.buttonsInSelectMode}
                  insideListWidget
                  actions={actions}
                  rowId={row?.api_rowMetaData?.recordId}
                  rowData={row}
                  widgetContext={{
                     isChatButtonVisible,
                     chatTitleKey: chatButtonTranslationKey,
                     currentWidget,
                     columns,
                  }}
                  saveCallback={toggle}
                  listId={listId}
               />
            )}
            {typeof value === "object" && value.value}

            {Array.isArray(value) && singleColumn === "api_instancestatus" ? (
               <ProcessesDropdown api_instanceStatus={value} type={"list"} />
            ) : null}
            {/*  Basic cell, not object value */}
            {typeof value !== "object" && returnBasicCellValue(value)}
         </div>
      );
   }
};

export default ListCell;
